import { useQuery } from '@tanstack/react-query';
import { getAiTokens } from 'api/services';

const useAiTokenQuery = () => {
    return useQuery({
        queryKey: ['aiToken'],
        queryFn: () => getAiTokens(),
    });
};

export default useAiTokenQuery;
